
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcUserMenu as ObcUserMenuElement} from '@oicl/openbridge-webcomponents/dist/components/user-menu/user-menu.js';
 
 
 

 
 export const ObcUserMenu = createComponent({
   react: React,
   tagName: 'obc-user-menu',
   elementClass: ObcUserMenuElement,
   events: {
     
     onSignInClick: 'sign-in-click' as EventName<CustomEvent<{username: string, password: string}>>,
     onSignOutClick: 'sign-out-click' as EventName<CustomEvent<unknown>>,
     onSignedInActionClick: 'signed-in-action-click' as EventName<CustomEvent<{id: string, label: string}>>,
     onRecentUserClick: 'recent-user-click' as EventName<CustomEvent<{initials: string, label: string}>>,
   }
  });
 
 